import PanelSmsVerification from './PanelSmsVerification';
export default PanelSmsVerification;

// import { FormSmsVerification } from './FormSmsVerification';
// export { FormSmsVerification };
